import clsx from 'clsx'
import { FieldError, Label } from 'components/core-v2'
import { Controller, RegisterOptions, useFormContext } from 'react-hook-form'
import { NumericFormat } from 'react-number-format'
import { ClassName } from 'types/props'

import inputClasses from '../../atoms/input/index.module.scss'
import { getFieldIds } from './__utils__/getFieldIds'
import classes from './currency-field-v2.module.scss'
import fieldClasses from './field.module.scss'

export interface Props extends ClassName {
  id: string
  isDisabled?: boolean
  label: string
  placeholder?: string
  prefix?: string
  showError?: boolean
  validators?: RegisterOptions
}

export const CurrencyFieldV2 = ({
  className,
  id,
  isDisabled = false,
  label,
  placeholder,
  prefix = 'R',
  showError = true,
  validators,
  ...props
}: Props) => {
  const {
    control,
    formState: { errors }
  } = useFormContext()

  const error = errors[id]?.message
  const hasError = Boolean(error)
  const { describedBy, errorId, inputId } = getFieldIds(id)
  return (
    <div className={clsx(className)}>
      <Label className={fieldClasses.label} htmlFor={id}>
        {label}
      </Label>
      <Controller
        control={control}
        name={id}
        render={({ field }) => (
          <div className={classes.inputWrapper}>
            <span className={classes.prefix}>{prefix}</span>
            <NumericFormat
              allowNegative={false}
              aria-describedby={describedBy}
              className={clsx(inputClasses.root, classes.input, {
                [inputClasses.hasError]: hasError
              })}
              decimalScale={2}
              disabled={isDisabled}
              id={id}
              name={inputId}
              placeholder={placeholder}
              thousandSeparator=","
              thousandsGroupStyle="thousand"
              type="text"
              {...props}
              {...field}
            />
          </div>
        )}
        rules={validators}
      />
      {error && showError && <FieldError id={errorId}>{String(error)}</FieldError>}
    </div>
  )
}
